import {Form} from "../../form/form";

export class WebModuleWorkerForm extends Form{
    ready(){
        super.ready();
        this.$cacheFields = this.findMember("cache-fields");
        this.$visibilityFields = this.findMember("visibility-fields");

        this.findMember("cache-button").click(
            (ev)=>{
                ev.preventDefault();
                this.$cacheFields.toggle();
            }
        );
        this.findMember("visibility-button").click(
            (ev)=>{
                ev.preventDefault();
                this.$visibilityFields.toggle();
            }
        );
    }
}

